import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=1e9a0784&scoped=true&"
var script = {}
import style0 from "./err404.vue?vue&type=style&index=0&id=1e9a0784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9a0784",
  null
  
)

export default component.exports